import { useNavigate } from "react-router-dom";
import { plus } from "../../../asset";
import DataTable, { Column } from "../../../components/DataTable";
import SubButton from "../../../components/SubButtons";
import { Student } from "../../../types/studentType";
import useConfirmToast from "../../../util/hooks/useConfirmToast";
import { toast } from "sonner";
import GroupApis from "../../../api/groupApis";

interface Props {
  admissionNumber?: number;
  groupId?: number | null;
  groupName?: string;
}

export default function Others({ admissionNumber, groupId, groupName }: Props) {
  const { confirm, modal } = useConfirmToast();
  const navigate = useNavigate();
  const studentList =
    groupId && groupName
      ? [
          {
            admissionNumber,
            groupId,
            groupName,
          },
        ]
      : [];

  const handleDelete = async () => {
    if (!groupId || !admissionNumber) return;

    const ifOk = await confirm(
      "Are you sure you want to remove this student from the group?",
    );
    if (!ifOk) return;

    try {
      await GroupApis.removeStudent(groupId, admissionNumber);
      toast.success("Student removed from group");

      navigate(`/all-students`);
    } catch {
      // error toast already handled
    }
  };

  const columns: Column<Student>[] = [
    {
      label: "SL NO.",
      accessor: "admissionNumber",
    },
    {
      label: "Group/House Name",
      accessor: "groupHouse",
      render: (item) => (
        <span className="text-neutral-400 font-bold">{item.groupName}</span>
      ),
    },
    {
      label: "Action",
      accessor: "action",
      render: (item) => (
        <button
          onClick={handleDelete}
          className="px-2 py-1 flex gap-2 items-center text-nowrap text-xs text-error-700 bg-error-50 rounded-[4px] font-medium"
        >
          Delete
        </button>
      ),
    },
  ];
  return (
    <div className="px-11 py-12 flex flex-col gap-14">
      <DataTable columns={columns} data={studentList} />
      {studentList.length > 0 && (
        <SubButton
          onClick={() => navigate(`/groups-houses/add-group`)}
          color="bg-success-600"
          text="Add to new group/house"
          icon={plus}
        />
      )}
      {modal}
    </div>
  );
}
